import { useNavigate, useParams } from 'react-router-dom';
import { Button, Panel } from 'nhsuk-react-components';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails';

function TeamCohortsConfirmationPage() {
  const { teamId } = useParams() as { teamId: string };
  const navigate = useNavigate();

  const { data: teamDetails, isLoading: isTeamDetailsLoading } = useFetchTeamDetails({ teamId });

  const handleContinue = () => {
    navigate(`/admin/${teamId}/team-cohorts`);
  };

  if (isTeamDetailsLoading) {
    return (
      null
    );
  }

  return (
    <>
      <Panel>
        <Panel.Title>
          &apos;
          {teamDetails?.team.TEAM_NAME ?? teamId}
          &apos;
          {' '}
          cohorts have been updated
        </Panel.Title>
        <div>
          The next screen will show your selected cohorts in a non-editable table.
        </div>
        <div className="nhsuk-u-margin-top-4">
          If you would like to change this selection click &apos;Edit chosen cohorts&apos;.
        </div>
      </Panel>
      <Button onClick={handleContinue}>Continue</Button>
    </>
  );
}

export default TeamCohortsConfirmationPage;
